module.exports = __webpack_public_path__ + "img/logo_a.b4be53ea.png";